import { render } from "./CreateReferralHomeHealth.vue?vue&type=template&id=685a2cf1&ts=true"
import script from "./CreateReferralHomeHealth.ts?vue&type=script&lang=ts&external"
export * from "./CreateReferralHomeHealth.ts?vue&type=script&lang=ts&external"

import "./CreateReferralHomeHealth.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__